import { render } from "./clientCrudPopUp.vue?vue&type=template&id=39c32d3c"
import script from "./clientCrudPopUp.vue?vue&type=script&lang=js"
export * from "./clientCrudPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__